import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Segment, Form, Button, Container, Grid, Header, Icon, Label, Dropdown, Image } from 'semantic-ui-react'

import KnaufLogoCloud from "../../assets/img/KnaufLogoCloud.png";

import { Link } from 'react-router-dom'

import API from'../../services/Api'
import _ from 'lodash'

// import './RegisterComponent.css'

import { translate } from "react-translate"

const rightOptions = [
    {key: '4', text:'value_table_particuliers', value:'4'},
    {key: '3', text:'value_table_enterprises', value:'3'},
    {key: '2', text:'value_table_prescripteurs', value:'2'},
    // {key: '1', text:'Commerciaux', value:'1'},
    // {key: '0', text:'Administrateur', value:'0'},
]

class ConnectedRegister extends Component {
    constructor(props){
        super(props)

        this.state = {
            email: null,
            password: null,
            name: null,
            job: null,
            country: null,
            postalcode: null,
            error: null,
            response: null
        }

        // Handle Change
        this.handleChangeEmail = this.handleChangeEmail.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.handleChangeName = this.handleChangeName.bind(this);
        this.handleChangeJob = this.handleChangeJob.bind(this);
        this.handleChangePostalcode = this.handleChangePostalcode.bind(this);

        // Handle Submit
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillMount(){
        let { t } = this.props
        var rightOptionsCopy = _.clone(rightOptions)
        rightOptionsCopy = _.map(rightOptionsCopy, x => {
            return {
                ...x,
                text:t(x.text)
            }
        })
        this.setState({
            rightOptions : rightOptionsCopy
        })
    }

    handleSubmit(event){
        event.preventDefault();

        if(this.state.email === null || this.state.password === null || this.state.name === null
            // || this.state.gender === null || this.state.country === null || this.state.postalcode === null
            ){

                this.setState({
                    error: "Erreur"
                })
            }

            // API.addClient({
            //     ...this.state,
            //     username : this.state.email,
            //     surname: this.state.name,
            //     job: Number(this.state.job) || 0,
            //     postalcode: this.state.postalcode,
            //     created: new Date(),
            // }).then(res => {
            //     var response = res.data
            //     this.setState({response})
            // })

            

     }

     sendUser(){
        var form = new FormData();
        form.append('name', this.state.name)
        form.append('username', this.state.name)
        form.append('surname', this.state.email)
        form.append('email', this.state.email)
        form.append('password', this.state.password)
        form.append('job', Number(this.state.job) || 0) 
        form.append('postalcode', this.state.postalcode)
        API.addClient(form)
        this.setState({
            loading: false
        })      
    }

    handleChangeEmail(event) {
        this.setState({email: event.target.value});
    }
    handleChangePassword(event) {
        this.setState({password: event.target.value});
    }
    handleChangeName(event) {
        this.setState({name: event.target.value});
    }
    handleChangeJob(event, val) {
        this.setState({job: val.value});
    }
    handleChangePostalcode(event) {
        this.setState({postalcode: event.target.value});
    }

    render() {
        let {t} = this.props

        return (
            <Segment basic id='registerMain'>
                <Container>
                    <Image src={KnaufLogoCloud} size="large" id="KnaufLogoCloud" />
                    <Segment className='windowRegister'>
                        <Grid textAlign='center' verticalAlign='middle'>
                            <Grid.Column className='columnRegister'>
                                <Header as='h3' style={{ marginTop: '-6%' }} textAlign='center' >
                                    <Link to='/'>
                                    <Icon name='times' className='closeIcon' floated='right' /></Link>
                                    {t("register_title")}
                                    {/* INSCRIPTION */}
                                    <div class='ui divider' />
                                </Header>
                                <Form className="ui form">
                                    <h4 className='labelstyling'>
                                    {t("register_name")}
                                    {/* NOM  */}
                                    <span className='spanColor'>*</span></h4>
                                    <Form.Input
                                        onChange={this.handleChangeName}
                                    />

                                    <h4 className='labelstyling'>
                                    {t("register_email")}
                                    {/* E-MAIL ADRESS  */}
                                    <span className='spanColor'>*</span></h4>
                                    <Form.Input
                                        type="email"
                                        onChange={this.handleChangeEmail}
                                    />

                                    <h4 className='labelstyling'>
                                    {t("register_password")}
                                    {/* MOT DE PASSE  */}
                                    <span className='spanColor'>*</span></h4>
                                    <Form.Input
                                        type="password"
                                        onChange={this.handleChangePassword}
                                    />

                                  <h4 className='labelstyling'>
                                  {t("register_category")}
                                  {/* CATEGORIE  */}
                                  <span className='spanColor'>*</span></h4>
                                    <Dropdown
                                        placeholder='Entreprise'
                                        fluid
                                        selection
                                        options={this.state.rightOptions || []}
                                        onChange={this.handleChangeJob}
                                    />

                                    <h4 className='labelstyling'>
                                    {t("register_postalcode")}
                                    {/* CODE POSTAL  */}
                                    <span className='spanColor'>*</span></h4>
                                    <Form.Input
                                        onChange={this.handleChangePostalcode}
                                    />

                                    <Button type="submit" fluid className="ui button" role="button" className='buttonSubmit'onClick={() => this.sendUser()}>
                                    {t("register_signin")}
                                    {/* INSCRIPTION */}
                                    </Button>

                                    <Segment basic>
                                      <span className="lightGrey">
                                      {t("already_account")}
                                      {/* Vous avez déjà un compte?  */}
                                      </span>
                                      <Link to='/login' className='linkPath' id="createAccount">
                                      {t("register_connect")}
                                      {/* Connexion */}
                                      </Link>
                                    </Segment>
                                </Form>
                            </Grid.Column>
                        </Grid>
                    </Segment>
                </Container>
            </Segment>
        );
    }
}

const Register = (ConnectedRegister);

export default translate('Register')(Register);



// WEBPACK FOOTER //
// ./src/components/Register/RegisterComponent.jsx